import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import Routes from "../../../navigation/route/Route";
import EditBrandForm from "./form/edit/EditBrandForm";
import Brand from "../../../model/brand/Brand";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";

interface ReduxProps {
	brand?: Brand;
}

interface RouteProps {
	brandId: string
}

type Props = RouteComponentProps<RouteProps> & ReduxProps;

/**
 * Create brand.
 */
class BrandEdit extends React.PureComponent <Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		console.log("siema")
		if (!this.props.brand)
			return null;

		return (
			<Boxed>
				<PageHeaderView header={"Edit brand"}/>
				<PageContentView>
					<EditBrandForm brand={this.props.brand} onSuccess={this.onSuccess} onCancel={this.onCancel}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On brand edited.
	 */
	private onSuccess() {
		this.props.history.push(Routes.BrandList);
	}

	/**
	 * On cancel click.
	 * Redirect to previous page.
	 */
	private onCancel() {
		this.props.history.goBack();
	}
}

function mapStateToProps(state: RootState, props: RouteComponentProps<RouteProps>) {
	return {
		brand: state.brand.brands.getOrElse([]).filter(b => b.id == props.match.params.brandId)[0]
	}
}

export default withRouter(connect<ReduxProps>(mapStateToProps)(BrandEdit));